import { createRouter, RouteRecordRaw, createWebHashHistory } from 'vue-router';
import { checkTeslaRightStatus, checkOtherRightStatus } from '../core/guard';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: () => '/404',
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "inviteCode" */ '../views/404.vue'),
  },
  // {
  // 产品要下线处理
  //   path: '/teslaRegister',
  //   name: 'teslaRegister',
  //   component: () => import(/* webpackChunkName: "inviteCode" */ '../views/teslaRegister/index.vue'),
  // },
  {
    path: '/inviteCodeEntrance',
    name: 'InviteCodeEntrance',
    component: () => import(/* webpackChunkName: "inviteCode" */ '../views/inviteCode/Entrance.vue'),
  },
  {
    path: '/inviteCodeMerchant',
    name: 'InviteCodeMerchant',
    component: () => import(/* webpackChunkName: "inviteCode" */ '../views/inviteCode/InviteCodeMerchant.vue'),
  },
  {
    path: '/inviteCodePersonal',
    name: 'InviteCodePersonal',
    component: () => import(/* webpackChunkName: "inviteCode" */ '../views/inviteCode/InviteCodePersonal.vue'),
  },
  {
    path: '/inviteCodeShare',
    name: 'InviteCodeShare',
    component: () => import(/* webpackChunkName: "inviteCode" */ '../views/inviteCode/InviteCodeShare.vue'),
  },
  {
    path: '/inviteCodeM1',
    name: 'InviteCodeM1',
    component: () => import(/* webpackChunkName: "mgm" */ '../views/inviteCode/M1.vue'),
  },
  {
    path: '/inviteCodeM2',
    name: 'InviteCodeM2',
    component: () => import(/* webpackChunkName: "mgm" */ '../views/inviteCode/M2.vue'),
  },
  {
    path: '/inviteCodeRecordList',
    name: 'InviteCodeRecordList',
    component: () => import(/* webpackChunkName: "inviteCode" */ '../views/inviteCode/RecordList.vue'),
  },
  {
    path: '/carOwnerRightEntrance',
    name: 'CarOwnerRightEntrance',
    component: () => import(/* webpackChunkName: "carOwnerRight" */ '../views/carOwnerRight/Entrance.vue'),
  },
  {
    path: '/teslaRightOverview',
    name: 'TeslaRightOverview',
    component: () => import(/* webpackChunkName: "carOwnerRight" */ '../views/carOwnerRight/TeslaOverview.vue'),
    beforeEnter: [checkTeslaRightStatus]
  },
  {
    path: '/otherRightOverview',
    name: 'OtherRightOverview',
    component: () => import(/* webpackChunkName: "carOwnerRight" */ '../views/carOwnerRight/OtherOverview.vue'),
    beforeEnter: [checkOtherRightStatus]
  },
  // {
  // 产品要下线处理
  //   path: '/otherRegister',
  //   name: 'otherRegister',
  //   component: () => import(/* webpackChunkName: "otherRegister" */ '../views/carOwnerRight/OtherRegister.vue'),
  // },
  {
    path: '/teslaOrder',
    name: 'TeslaOrder',
    component: () => import(/* webpackChunkName: "carOwnerRight" */ '../views/carOwnerRight/TeslaOrder.vue'),
  },
  {
    path: '/rightMerchant',
    name: 'RightMerchant',
    component: () => import(/* webpackChunkName: "carOwnerRight" */ '../views/carOwnerRight/RightMerchant.vue'),
  },
  {
    path: '/rightMy',
    name: 'RightMy',
    component: () => import(/* webpackChunkName: "carOwnerRight" */ '../views/carOwnerRight/RightMy.vue'),
  },
  {
    path: '/rightDetail',
    name: 'RightDetail',
    component: () => import(/* webpackChunkName: "carOwnerRight" */ '../views/carOwnerRight/RightDetail.vue'),
  },
  {
    path: '/rightState',
    name: 'RightState',
    component: () => import(/* webpackChunkName: "carOwnerRight" */ '../views/carOwnerRight/RightState.vue'),
  },
  {
    path: '/recordList',
    name: 'RecordList',
    component: () => import(/* webpackChunkName: "recordList" */ '../views/carOwnerRight/RecordList.vue'),
  },
  {
    path: '/recordCashDetail',
    name: 'RecordCashDetail',
    component: () => import(/* webpackChunkName: "recordList" */ '../views/carOwnerRight/RecordDetail.vue'),
  },
  {
    path: '/comfirmAddress',
    name: 'ComfirmAddress',
    component: () => import(/* webpackChunkName: "recordList" */ '../views/carOwnerRight/ComfirmAddress.vue'),
  },
  {
    path: '/lease',
    name: 'Lease',
    component: () => import(/* webpackChunkName: "lease" */ '../views/lease/index.vue'),
  },
  {
    path: '/leaseIntegrate',
    name: 'LeaseIntegrate',
    component: () => import(/* webpackChunkName: "lease" */ '../views/lease/integrate.vue'),
  },
  {
    path: '/leaseCal',
    name: 'leaseCal',
    component: () => import(/* webpackChunkName: "lease" */ '../views/lease/leaseCal.vue'),
  },
  {
    path: '/commonRegister',
    name: 'CommonRegister',
    component: () => import(/* webpackChunkName: "commonRegister" */ '../views/commonRegister/form.vue'),
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
